'use client'

import { cn } from '@/lib/utils'

type InviteBadgeProps = {
  name?: string | null
  avatarUrl?: string | null
  label?: string
}

export function InviteBadge({ name, avatarUrl, label }: InviteBadgeProps) {
  if (!name) return null

  const initials = name
    .split(' ')
    .map(n => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return (
    <div className="flex items-center gap-2 mb-4 text-sm text-muted-foreground">
      {/* Avatar */}
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={name}
          className="w-6 h-6 rounded-full object-cover border"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-muted flex items-center justify-center text-xs font-medium text-foreground">
          {initials}
        </div>
      )}

      {/* Texto */}
      <span className="leading-none">
        <span className="font-medium text-foreground">{name}</span>
        <span className="mx-1">•</span>
        <span>{label}</span>
      </span>
    </div>
  )
}